import { combineReducers } from 'redux'
import mapValues from 'lodash/mapValues'
import { getReducers } from '@blocket/authentication-fe'
import { routerReducer } from 'connected-next-router'

import { reducer as footerWidget } from 'plugins/footer/reduxBit/reducer'
import { reducer as adWatchesCount } from 'plugins/adWatchesCount/reduxBit/reducer'
import { reducer as device } from 'plugins/device/reduxBit/reducer'
import { reducer as account } from './account'
import { reducer as adBlocker } from './adBlocker'
import { reducer as classified } from './classified'
import { reducer as config } from './config'
import { reducer as navigation } from './navigation'
import { reducer as searchParams } from './searchParams'
import { reducer as transactions } from './transactions'
import { reducer as newsletterOptOut } from './newsletterOptOut'
import { reducer as chat } from './chat/reducer'
import { reducer as privateProfile } from './privateProfile/reducer'
import { reducer as optimizely } from './optimizely/reducer'
import { reducer as ui } from './ui/reducer'

export default combineReducers({
  ...mapValues(getReducers(), (value) => value.reducer),
  account,
  transactions,
  adBlocker,
  classified,
  config,
  navigation,
  searchParams,
  newsletterOptOut,
  chat,
  footerWidget,
  adWatchesCount,
  device,
  privateProfile,
  optimizely,
  ui,
  router: routerReducer,
})

export const reduxMiddlewares = [
  () => (next) => (action) => {
    try {
      next(action)
    } catch (error) {
      console.log(error, 'ERROR IN reduxMiddlewares')
    }
  },
]
